import { render, staticRenderFns } from "./AddItemToCartViaExternalSystem.vue?vue&type=template&id=064b8ed3&"
import script from "./AddItemToCartViaExternalSystem.vue?vue&type=script&lang=ts&"
export * from "./AddItemToCartViaExternalSystem.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports